module.exports = __webpack_public_path__ + "static/img/airtel.5279720.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/airtel.png
// module id = i5ix
// module chunks = 1